import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import StyledButton, { IStyledButtonProps } from "components/buttons/StyledButton";
import OmitType from "customTypes/OmitType";
import NewTabLinkButton from "components/buttons/NewTabLinkButton";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            minWidth: 175,
            marginRight: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
    })
);

interface IProps extends OmitType<OmitType<IStyledButtonProps, "size">, "id"> {
    href?: string;
    gtmSelector: string;
}

export default function SelectionButton(props: IProps) {
    const classes = useStyles();

    const { href, className, gtmSelector, ...rest } = props;

    const commonProps = {
        size: "medium" as "medium",
        className: clsx(className, classes.root, gtmSelector),
    };

    return typeof href === "undefined" ? (
        <StyledButton {...commonProps} {...rest} />
    ) : (
        <NewTabLinkButton {...commonProps} href={href} {...rest} />
    );
}
